import { CheckIcon } from "@heroicons/react/outline";

const phases = [
    {
        title: "Fase 1",
        category: { name: "Week 0 - 4" },
        description:
            "Fase 1 is de start van jouw verbluffende transformatie! We starten met een uitgebreide meting en een intake formulier. Op basis van deze informatie wordt een effectief persoonlijk plan opgesteld voor jouw transformatie. Samen met je trainer ga jij deze periode aan de slag om de eerste resultaten neer te zetten.",
        features: [
            "Nul meting en uitgebreide intake formulier",
            "Persoonlijk voeding,- en traingingsschema",
            "2 tot 4 keer per week trainen samen met je trainer",
            "Dagelijks contact met je trainer over de vooruitgang",
            "Voedinglijst en kookboeken ter inspirattie voor variatie",
            "Mentale coaching om een terugval te voorkomen",
        ],
        imageSrc: "/assets/about/custom.jpg",
        imageSrcWebp: "/assets/about/webp/custom.webp",
    },
    {
        title: "Fase 2",
        category: { name: "Week 5 - 8" },
        description:
            "Na vier weken heb je al resultaten behaald waar je normaliter maanden over zou doen. Om dit te versterken stap je samen met je coach over naar fase 2. Je bent fitter, sterker en slanker dan ooit te voren maar je lichaam raakt gewend aan de prikkels. Om deze reden veranderen we je voeding,- en trainingsschema zodat je resultaat niet gaat stagneren maar nog beter wordt!",
        features: [
            "Tussenmeting om de vooruitgang in beeld te brengen",
            "Een nieuw persoonlijk voeding,- en trainingsschema",
            "2 tot 4 keer per week trainen samen met je trainer",
            "Dagelijks contact met je trainer over de vooruitgang",
            "Voedinglijst en kookboeken ter inspiratie voor variatie",
            "Mentale coaching om een terugval te voorkomen",
        ],
        imageSrc: "/assets/about/quality.jpg",
        imageSrcWebp: "/assets/about/webp/quality.webp",
    },
    {
        title: "Fase 3",
        category: { name: "Week 9 - 12" },
        description:
            "Na acht weken training heb je nooit eerder behaalde resultaten weten te realiseren maar we gaan voor meer in fase 3! Opnieuw is het nodig om je lichaam nieuwe prikkels te geven zodat je resultaten nog beter worden. Je gewicht blijft hierdoor dalen, je spieren blijven hierdoor groeien en je voelt je fitter dan ooit! In fase 3 gaan we dus opnieuw je voeding,- en trainingsschema aanpassen om dit te realiseren.",
        features: [
            "Tussenmeting om de vooruitgang in beeld te brengen",
            "Een nieuw persoonlijk voeding,- en trainingsschema",
            "2 tot 4 keer per week trainen samen met je trainer",
            "Dagelijks contact met je trainer over de vooruitgang",
            "Voedinglijst en kookboeken ter inspiratie voor variatie",
            "Mentale coaching om een terugval te voorkomen",
        ],
        imageSrc: "/assets/about/physic.jpg",
        imageSrcWebp: "/assets/about/webp/physic.webp",
    },
    {
        title: "Fase 4",
        category: { name: "Exclusieve nazorg" },
        description:
            "Na twaalf weken training heb je resultaten behaald waarvan je dacht dat ze onmogelijk waren! Terwijl je nog de blijdschap van je prestatie voelt krijg je van ons een keuze. Omdat je twaalf weken training hebt gevolgd kan je kiezen om het avontuur met je coach te verlengen of je kunt overstappen naar onze private gym waarin je onbeperkt nazorg krijgt om de behaalde resultaten te onderhouden.",
        features: [
            "Onbeperkt (vrij) trainen op beide locaties",
            "Onbeperkt deelname aan al onze groeplessen",
            "Een maandelijkse update gesprek met onze open gym coach",
            "Voeding,- en trainingsbegeleiding",
            "Trainen in een ruimte zonder bodybuilders",
            "Maximaal tien personen per tijdseenheid",
            "Geopend van 6.00u tot 23.00u | 7 dagen per week",
        ],
    },
];

export default () => {
    return (
        <div className="relative xs:pb-8 sm:pb-8 md:pb-16 lg:pb-16">
            <div className="absolute inset-0">
                <div className="bg-black h-1/3 sm:h-2/3" />
            </div>
            <div className="relative max-w-7xl mx-auto">
                <div className="text-center">
                    <h2 className="mt-2 xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl text-white font-custom italic font-bold uppercase">
                        De WE ARE Methode
                    </h2>
                    <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-100 sm:mt-4">
                        Dit zijn de verschillende fases van de WE ARE Methode.
                        Tijdens deze periode van intensieve begeleiding en
                        exclusieve nazorg zullen we je begeleiden op fysiek en
                        mentaal gebied.
                    </p>
                </div>
                {/* <img src="/assets/phases.png" alt="Phases" className="my-8" /> */}
                <img
                    src="/assets/phases-alt.jpg"
                    alt="Phases"
                    className="my-8"
                />

                <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-2 lg:max-w-none">
                    {phases.map((phase) => (
                        <div
                            key={phase.title}
                            className="flex flex-col rounded-lg shadow-lg overflow-hidden"
                        >
                            <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                                <div className="flex-1">
                                    <p className="text-base font-medium text-we-are-purple">
                                        <a
                                            href={phase.category.href}
                                            className="hover:underline"
                                        >
                                            {phase.category.name}
                                        </a>
                                    </p>
                                    <a href={phase.href} className="block mt-2">
                                        <p className="text-xl font-bold text-gray-900">
                                            {phase.title}
                                        </p>
                                        <p className="mt-3 text-base text-gray-500">
                                            {phase.description}
                                        </p>
                                    </a>
                                    <div className="mt-3">
                                        <ul className="">
                                            {phase.features.map(
                                                (feature, key) => (
                                                    <li
                                                        key={key}
                                                        className="ml-0 pl-0"
                                                    >
                                                        <CheckIcon
                                                            className="absolute h-6 w-6 text-green-500"
                                                            aria-hidden="true"
                                                        />
                                                        <p className="ml-9 text-base text-gray-500">
                                                            {feature}
                                                        </p>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {phase.imageSrcWebp ? (
                                <div className="block sm:hidden mt-4">
                                    <picture>
                                        <source
                                            srcSet={phase.imageSrcWebp}
                                            width="1440"
                                            height="960"
                                            type="image/webp"
                                            alt="Transformaties personal training Uden en Schijndel"
                                            className="w-full h-82 object-cover mt-8"
                                        />
                                        <source
                                            srcSet={phase.imageSrc}
                                            width="1440"
                                            height="960"
                                            type="image/jpeg"
                                            alt="Transformaties personal training Uden en Schijndel"
                                            className="w-full h-82 object-cover mt-8"
                                        />
                                        <img
                                            src={phase.imageSrc}
                                            width="1440"
                                            height="960"
                                            alt="Transformaties personal training Uden en Schijndel"
                                            className="w-full h-82 object-cover mt-8"
                                        />
                                    </picture>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
